// removed by extract-text-webpack-plugin
module.exports = {"colored-background":"colored-background___aH1qA","coloredBackground":"colored-background___aH1qA"};